import { render } from "./Settings.vue?vue&type=template&id=1c97d72e&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=1c97d72e&lang=scss&scoped=true"
import "./Settings.vue?vue&type=style&index=1&id=1c97d72e&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c97d72e"]])

export default __exports__